import { DatePipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';
import { AuthenticationService } from 'src/app/core/auth/authentication.service';
@Pipe({
    name: 'epgDate',
})
export class EpgDatePipe implements PipeTransform {

    constructor(
        private datePipe: DatePipe, 
        private authService: AuthenticationService
    ) { }

    transform(value: Date | string | undefined, format: string = 'mediumDate'): string | null {
        if(value) {
            let year: number, month: number, day: number;
            
            // Check if the input is an ISO date-only string (YYYY-MM-DD format)
            if (typeof value === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(value.trim())) {
                // Parse ISO date-only strings directly without timezone conversion
                const parts = value.trim().split('-');
                year = parseInt(parts[0], 10);
                month = parseInt(parts[1], 10) - 1; // Month is 0-indexed
                day = parseInt(parts[2], 10);
            } else {
                // For other formats (including "Jan 20, 2026") and dates with time/timezone info
                const dateValue = new Date(value);
                
                // Check if the input has timezone or time information
                const hasTimeOrTimezone = typeof value === 'string' && 
                    (/T\d{2}:\d{2}/.test(value) || /[+-]\d{2}:\d{2}/.test(value) || /Z$/.test(value));
                
                if (hasTimeOrTimezone) {
                    // For dates with time/timezone info, extract UTC components
                    year = dateValue.getUTCFullYear();
                    month = dateValue.getUTCMonth();
                    day = dateValue.getUTCDate();
                } else {
                    // For date-only formats like "Jan 20, 2026", use local getters
                    year = dateValue.getFullYear();
                    month = dateValue.getMonth();
                    day = dateValue.getDate();
                }
            }
            
            // Create a new date in the user's local timezone with the extracted date
            const localDate = new Date(year, month, day, 12, 0, 0, 0);
            const formattedDate = this.datePipe.transform(localDate, format, undefined, this.authService.localeLang);
            return formattedDate;
        }
       return null;
    }

}
